import { getAppType } from '@/lib/offline/OfflineAppHelper';
import * as Sentry from '@sentry/react';
import { useEffect } from 'react';

const overrideNavigatorOnline = (value: boolean) => {
  // APL-5761, In case of iPad in latest OS (iOS 17.6 onwards) AAC Mode security, navigator.onLine is always false, so we need to override it to support Wiris math
  try {
    // Check if the property is already defined and configurable
    const descriptor = Object.getOwnPropertyDescriptor(window.navigator, 'onLine');

    if (!descriptor || descriptor.configurable) {
      Object.defineProperty(window.navigator, 'onLine', {
        get: function () {
          return value;
        },
        configurable: true,
      });
    } else {
      console.log('navigator.onLine property is not configurable.');
      Sentry.captureException(new Error('navigator.onLine property is not configurable.'));
    }
  } catch (error) {
    console.log('error in overriding navigator online ==>', error);
    Sentry.captureException(error);
  }
};

export const useOverrideNavigator = ({ isOnline }: any) => {
  const appType = getAppType();

  useEffect(() => {
    if (appType === 'ios') {
      overrideNavigatorOnline(isOnline);
    }
  }, [isOnline, appType]);

  return null;
};
